// 删除token
export function removeToken(successCallback) {
  // Cookies.remove(UserEnum.TOKEN_KEY);
  // sessionStorage.removeItem(UserEnum.TOKEN_KEY);
  successCallback && successCallback();
}
